import { EllipsisOutlined } from '@ant-design/icons'
import { useToggle } from 'ahooks'
import { Button, Dropdown, Menu } from 'antd'
import React from 'react'

import { PostTypeIcon } from '@/components'
import { PostType, SectionType } from '@/generated/graphql'
import { useIsSystemAdmin } from '@/modules/admin/admin.hooks'
import { AnnouncementPostModal } from '@/modules/post/announcement-post/announcement-post-modal.component'
import { EventPostModal } from '@/modules/post/event-post/event-post-modal.component'
import { HonorPostModal } from '@/modules/post/honor-post/honor-post-modal.component'

import { PostEditor } from './post-editor.component'

interface PostTypeMenuProps {
  sectionId?: SectionType
  groupId?: number
}

export const PostTypeMenu: React.FC<PostTypeMenuProps> = ({ groupId, sectionId }) => {
  const [postEditorVisible, setPostEditorVisible] = React.useState(false)
  const [menuVisible, { toggle: menuToggle }] = useToggle()
  const [postType, setPostType] = React.useState<PostType>(PostType.General)
  const isSystemAdmin = useIsSystemAdmin()

  const postEditor = (
    <PostEditor
      groupId={groupId}
      sectionId={sectionId}
      visible={postEditorVisible}
      onClose={() => setPostEditorVisible(false)}
      postType={postType}
    />
  )

  const normalButton = (
    <Menu.Item
      onClick={() => {
        setPostEditorVisible(true)
        setPostType(PostType.General)
      }}
      key={PostType.General}
    >
      <PostTypeIcon type={PostType.General} withText={true} />
    </Menu.Item>
  )

  const forumButton = (
    <Menu.Item
      onClick={() => {
        setPostEditorVisible(true)
        setPostType(PostType.Forum)
      }}
      key={PostType.Forum}
    >
      <PostTypeIcon type={PostType.Forum} withText={true} />
    </Menu.Item>
  )

  const journalButton = (
    <Menu.Item
      onClick={() => {
        setPostEditorVisible(true)
        setPostType(PostType.Journal)
      }}
      key={PostType.Journal}
    >
      <PostTypeIcon type={PostType.Journal} withText={true} />
    </Menu.Item>
  )

  const eventButton = (
    <Menu.Item key={PostType.Event}>
      <EventPostModal sectionId={sectionId} groupId={groupId}>
        <span>
          <PostTypeIcon type={PostType.Event} withText={true} />
        </span>
      </EventPostModal>
    </Menu.Item>
  )

  const announcementButton = (
    <Menu.Item key={PostType.Announcement}>
      <AnnouncementPostModal>
        <span>
          <PostTypeIcon type={PostType.Announcement} withText={true} />
        </span>
      </AnnouncementPostModal>
    </Menu.Item>
  )

  const honorButton = (
    <Menu.Item key={PostType.Honor}>
      <HonorPostModal sectionId={sectionId} groupId={groupId}>
        <span>
          <PostTypeIcon type={PostType.Honor} withText={true} />
        </span>
      </HonorPostModal>
    </Menu.Item>
  )

  const dropMenu = (
    <Menu onMouseLeave={() => menuToggle(false)}>
      {normalButton}
      {forumButton}
      {journalButton}
      {eventButton}
      {honorButton}
      {isSystemAdmin && announcementButton}
    </Menu>
  )
  return (
    <>
      {postEditor}
      <Dropdown trigger={['click']} {...(menuVisible && { visible: menuVisible })} overlay={dropMenu}>
        <Button shape='circle' icon={<EllipsisOutlined />} />
      </Dropdown>
    </>
  )
}
